import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19b99f0b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/monitor.less?vue&type=style&index=0&id=19b99f0b&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=19b99f0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b99f0b",
  null
  
)

export default component.exports